<template>
  <v-container fluid>
    <v-timeline dense>
      <v-timeline-item
        color="secondary"
        fill-dot
        v-for="(event, i) in events"
        right
        :key="i"
        :icon="event.status == 'Ongoing' ? 'mdi-play' : 'mdi-stop'"
      >
        <!-- {{ event.name }} -->
        <avs-card @click="handleClickEvent(event)">
          <template v-slot:title>
            <div>
              <v-icon color="secondary">{{ getIcon(event) }}</v-icon>
              <span
                class="ml-4 text-h6 font-weight-bold text-uppercase"
                v-if="event.object == 'Tracability'"
              >
                <!-- {{ event.entity }} -->
                {{ translatedEntity(event.entity) }}
              </span>
              <span
                class="ml-4 text-h6 font-weight-bold text-uppercase"
                v-else
              >
                {{ event.object }}
              </span>
              <span class="text-h6">
                - {{ event.name }}
                <template v-if="event.event == 'Rename'">({{ event.old_name }})</template>
              </span>
            </div>
            <span v-if="event.event !== 'Deleted' && event.event !== 'Signed'">
              <component
                class="mr-4"
                :is="handleStatusComponent(event)"
              />
            </span>
            <span v-else-if="event.event === 'Signed'">
              <v-chip
                class="ma-2"
                color="green"
                label
                text-color="white"
              >
                <v-icon left> mdi-draw </v-icon>
                {{ $t("commons.signed") }}
              </v-chip>
            </span>
            <span v-else>
              <v-chip
                class="ma-2"
                color="red"
                label
                text-color="white"
              >
                <v-icon left> mdi-close </v-icon>
                {{ $t("commons.deleted") }}
              </v-chip>
            </span>
          </template>

          <template v-slot:content
            ><v-divider></v-divider>

            <div class="primary--text mx-4 mt-4 pb-4 d-flex flex-column">
              <div class="d-flex justify-space-between">
                <span v-html="getEventText(event)"></span>
                <template>
                  <span v-if="event.object != 'Tracability'">
                    {{
                      event.date_type == "start"
                        ? $t("commons.date.start_date")
                        : $t("commons.date.end_date")
                    }}
                    : <b>{{ toDatetime(event.date) }}</b>
                  </span>
                  <span v-else>
                    <span
                      v-if="
                        event.entity != 'File' &&
                        event.entity != 'Folder' &&
                        event.entity != 'Report' &&
                        event.event != 'Deleted'
                      "
                    >
                      <template v-if="event.entity == 'NonConformity'">
                        {{ $t("commons.date.report_date") }}
                        : <b>{{ toDatetime(event.start_date) }}</b>
                      </template>
                      <template v-else-if="event.entity == 'Inspection'">
                        {{
                          event.status != "Closed"
                            ? $t("commons.date.start_date")
                            : $t("commons.date.end_date")
                        }}
                        :
                        <b>{{
                          event.status != "Closed"
                            ? toDatetime(event.start_date)
                            : toDatetime(event.end_date)
                        }}</b>
                      </template>
                      <template v-else-if="event.entity == 'Action'">
                        {{ $t("commons.date.end_date") }}
                        : <b>{{ toDatetime(event.end_date) }}</b>
                      </template>
                      <template v-else-if="event.entity == 'Task'">
                        {{
                          event.status != "Closed"
                            ? $t("commons.date.start_date")
                            : $t("commons.date.end_date")
                        }}
                        :
                        <b>{{
                          event.status != "Closed"
                            ? toDatetime(event.start_date)
                            : toDatetime(event.end_date)
                        }}</b>
                      </template>
                      <template v-else>
                        {{
                          event.date_type == "start"
                            ? $t("commons.date.start_date")
                            : $t("commons.date.end_date")
                        }}
                        : <b>{{ toDatetime(event.event_date) }}</b>
                      </template>
                    </span>
                  </span>
                </template>
              </div>
            </div></template
          >
        </avs-card>
      </v-timeline-item>
    </v-timeline>
  </v-container>
</template>

<script>
import { ProjectService } from "@/services"
import { toDatetime, toDate, toTime } from "@/utils/datetime"
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"

const E_OBJECTS = {
  ACTION: "Action",
  INSPECTION: "Inspection",
  NONCONFORMITY: "NonConformity",
  PROJECT: "Project",
  TASK: "Task",
  File: "File",
  Tracability: "Tracability"
}

export default {
  name: "ProjectFeed",
  components: { Closed, Ongoing, Overdue, Pending },
  data() {
    return {
      events: []
    }
  },
  mounted() {
    let t = this
    ProjectService.getFeed(this, this.projectId)
      .then(result => {
        t.events = result
      })
      .catch(err => {
        if (err.response && err.response.status === 403) {
          this.$store.commit("app/message", {
            msg: this.$t("messages.error.permission_denied"),
            color: "error"
          })
        }
      })
  },
  computed: {
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  methods: {
    toDatetime,
    toDate,
    toTime,
    getIcon(event) {
      const eObject = event.object
      if (eObject === E_OBJECTS.PROJECT) {
        return "mdi-home"
      } else if (eObject === E_OBJECTS.INSPECTION) {
        return "mdi-magnify-scan"
      } else if (eObject === E_OBJECTS.NONCONFORMITY) {
        return "mdi-clipboard-alert-outline"
      } else if (eObject === E_OBJECTS.TASK) {
        return "mdi-clock"
      } else if (eObject === E_OBJECTS.ACTION) {
        return "mdi-gesture-tap"
      } else if (eObject === E_OBJECTS.Tracability) {
        if (event.entity == "Inspection") {
          return "mdi-magnify-scan"
        }
        if (event.entity == "NonConformity") {
          return "mdi-clipboard-alert-outline"
        }
        if (event.entity == "Task") {
          return "mdi-clock"
        }
        if (event.entity == "Action") {
          return "mdi-gesture-tap"
        }
        if (event.entity == "Folder") {
          return "mdi-folder-outline"
        }
        if (event.entity == "File") {
          return "mdi-file-outline"
        }

        if (event.entity == "Report") {
          return "mdi-file-document-check-outline"
        }
        // return "mdi-file-outline"
      }
    },
    getTo(event) {
      const eObject = event.object
      const defaultTo = { name: "ProjectCreateUpdate", params: { id: this.projectId } }
      if (eObject === E_OBJECTS.PROJECT) {
        return { ...defaultTo, query: { tab: 1 } }
      } else if (eObject === E_OBJECTS.TASK || eObject === E_OBJECTS.STEP) {
        return { ...defaultTo, params: { id: this.projectId, tab: 2 } }
      } else if (eObject === E_OBJECTS.INSPECTION) {
        return { name: "Inspection", params: { id: event.id } }
      } else if (eObject === E_OBJECTS.NONCONFORMITY) {
        return { name: "NonConformityCreateUpdate", params: { id: event.id } }
      } else if (eObject === E_OBJECTS.ACTION) {
        return {
          name: "NonConformityCreateUpdate",
          params: { id: event.id, tab: 4 }
        }
      } else if (eObject === E_OBJECTS.Tracability) {
        if (event.entity == "Inspection") {
          return { name: "Inspection", params: { id: event.entity_id } }
        }
        if (event.entity == "NonConformity") {
          return { name: "NonConformityCreateUpdate", params: { id: event.entity_id } }
        }
        if (event.entity == "Task") {
          return { ...defaultTo, params: { id: this.projectId, tab: 2 } }
        }
        if (event.entity == "Action") {
          return {
            name: "NonConformityCreateUpdate",
            params: { id: event.entity_id, tab: 4 }
          }
        }
        if (event.entity == "Folder") {
          return defaultTo
        }
        if (event.entity == "File") {
          return defaultTo
        }
      } else {
        return defaultTo
      }
    },
    handleClickEvent(event) {
      this.$router.push(this.getTo(event))
    },
    handleStatusComponent(item) {
      return item.status
    },
    getEventText(event) {
      let text = ""
      switch (event.event) {
        case "Deleted":
          text = `
            ${this.$t("commons.delete_at")} : <b>${this.toDatetime(event.created_at)}</b>
            ${this.$t("commons.created_by_simple")} : <b>${event.created_by.full_name}</b>
          `
          break
        case "Signed":
          text = `
            ${this.$t("commons.sign_at")} : <b>${this.toDatetime(event.created_at)}</b>
            ${this.$t("commons.created_by_simple")} : <b>${event.created_by.full_name}</b>
          `
          break
        case "Modified":
          text = `
            ${this.$t("commons.updated_at")} : <b>${this.toDatetime(event.created_at)}</b>
            ${this.$t("commons.created_by_simple")} : <b>${event.created_by.full_name}</b>
          `
          break
        default:
          text = `
            ${this.$t("commons.created_at")} : <b>${this.toDatetime(event.created_at)}</b>
            ${this.$t("commons.created_by_simple")} : <b>${event.created_by.full_name}</b>
          `
          break
      }
      return text
    },
    translatedEntity(entity) {
      const translationKeys = {
        NonConformity: "commons.drawer.nonconformities",
        Inspection: "commons.drawer.inspections",
        Action: "commons.actions",
        Task: "commons.task",
        Folder: "commons.folder",
        File: "commons.file",
        Report: "commons.report"
      }

      if (entity === "Task" || entity === "Folder" || entity === "File") {
        return this.$tc(translationKeys[entity], 2)
      }
      return this.$t(translationKeys[entity])

      // return this.$t(translationKeys[entity])
    }
  }
}
</script>
